import { createApi } from "@reduxjs/toolkit/dist/query/react";

import { httpService } from "@services/http.service";

import { IGetAdsApiParams, IGetAdsApiResponse } from "./ads.types";

export const adsApi = createApi({
  reducerPath: "adsApi",
  baseQuery: httpService({
    baseUrl: `/api/v1`,
  }),
  tagTypes: ["adsData"],
  endpoints: (build) => ({
    getAds: build.query<IGetAdsApiResponse, IGetAdsApiParams>({
      query: ({ page }) => ({
        url: "/user/info/a/",
        method: "get",
        params: { page },
      }),
    }),
  }),
});

export const { useGetAdsQuery, useLazyGetAdsQuery } = adsApi;
